export enum TCoinTossEvents {
  BACK = 'BACK',
  BACK_TO_IDEL = 'BACK_TO_IDEL',
  ON_SELECTED_WINNER = 'ON_SELECTED_WINNER',
  ON_SELECTED_KICK_OR_RECEIVE = 'ON_SELECTED_KICK_OR_RECEIVE',
  ON_SELECTED_SIDE = 'ON_SELECTED_SIDE',
  TO_OFFENCE_DEFENCE = 'TO_OFFENCE_DEFENCE',
  TO_SELECT_SIDE = 'TO_SELECT_SIDE',
  BACK_TO_OFFENCE_DEFENCE = 'BACK_TO_OFFENCE_DEFENCE',
  TO_REGULAR_PLAY = 'TO_REGULAR_PLAY',
}

export enum TCoinTossStates {
  SELECT_WINNER = 'SELECT_WINNER',
  SELECT_KICK_OR_RECEIVE = 'SELECT_KICK_OR_RECEIVE',
  SELECT_OFFENCE_DEFENCE = 'SELECT_OFFENCE_DEFENCE',
  SELECT_SIDE = 'SELECT_SIDE',
}
